[
  {
    "date": "2025-12-03 13:00:00",
    "open": 0.000015,
    "low": 0.000015,
    "high": 0.000015,
    "close": 0.000015,
    "volume": 41493049
  },
  {
    "date": "2025-12-03 14:00:00",
    "open": 0.000015,
    "low": 0.0000147,
    "high": 0.0000151,
    "close": 0.0000149,
    "volume": 47057023
  },
  {
    "date": "2025-12-03 15:00:00",
    "open": 0.0000149,
    "low": 0.0000146,
    "high": 0.0000151,
    "close": 0.0000148,
    "volume": 46608561
  },
  {
    "date": "2025-12-03 16:00:00",
    "open": 0.0000148,
    "low": 0.0000148,
    "high": 0.0000148,
    "close": 0.0000148,
    "volume": 44903156
  },
  {
    "date": "2025-12-03 17:00:00",
    "open": 0.0000148,
    "low": 0.0000146,
    "high": 0.000015,
    "close": 0.0000147,
    "volume": 49887430
  },
  {
    "date": "2025-12-03 18:00:00",
    "open": 0.0000147,
    "low": 0.0000146,
    "high": 0.000015,
    "close": 0.0000148,
    "volume": 40323029
  },
  {
    "date": "2025-12-03 19:00:00",
    "open": 0.0000148,
    "low": 0.0000134,
    "high": 0.0000172,
    "close": 0.000016,
    "volume": 143836172
  },
  {
    "date": "2025-12-03 20:00:00",
    "open": 0.000016,
    "low": 0.0000155,
    "high": 0.0000161,
    "close": 0.0000158,
    "volume": 50520540
  },
  {
    "date": "2025-12-03 21:00:00",
    "open": 0.0000158,
    "low": 0.0000154,
    "high": 0.0000161,
    "close": 0.0000156,
    "volume": 57860568
  },
  {
    "date": "2025-12-03 22:00:00",
    "open": 0.0000156,
    "low": 0.0000149,
    "high": 0.0000159,
    "close": 0.0000153,
    "volume": 59723305
  },
  {
    "date": "2025-12-03 23:00:00",
    "open": 0.0000153,
    "low": 0.0000149,
    "high": 0.0000154,
    "close": 0.000015,
    "volume": 51688502
  },
  {
    "date": "2025-12-04 00:00:00",
    "open": 0.000015,
    "low": 0.000015,
    "high": 0.000015,
    "close": 0.000015,
    "volume": 63078934
  },
  {
    "date": "2025-12-04 01:00:00",
    "open": 0.000015,
    "low": 0.0000148,
    "high": 0.0000152,
    "close": 0.0000149,
    "volume": 44970766
  },
  {
    "date": "2025-12-04 02:00:00",
    "open": 0.0000149,
    "low": 0.0000145,
    "high": 0.0000154,
    "close": 0.0000151,
    "volume": 80109554
  },
  {
    "date": "2025-12-04 03:00:00",
    "open": 0.0000151,
    "low": 0.000015,
    "high": 0.0000152,
    "close": 0.0000152,
    "volume": 60027889
  },
  {
    "date": "2025-12-04 04:00:00",
    "open": 0.0000152,
    "low": 0.0000148,
    "high": 0.0000156,
    "close": 0.0000154,
    "volume": 50838947
  },
  {
    "date": "2025-12-04 05:00:00",
    "open": 0.0000154,
    "low": 0.0000149,
    "high": 0.0000156,
    "close": 0.0000152,
    "volume": 55609769
  },
  {
    "date": "2025-12-04 06:00:00",
    "open": 0.0000152,
    "low": 0.0000152,
    "high": 0.0000156,
    "close": 0.0000154,
    "volume": 41807515
  },
  {
    "date": "2025-12-04 07:00:00",
    "open": 0.0000154,
    "low": 0.0000152,
    "high": 0.0000155,
    "close": 0.0000153,
    "volume": 48198040
  },
  {
    "date": "2025-12-04 08:00:00",
    "open": 0.0000153,
    "low": 0.0000149,
    "high": 0.0000157,
    "close": 0.0000151,
    "volume": 47313439
  },
  {
    "date": "2025-12-04 09:00:00",
    "open": 0.0000151,
    "low": 0.0000149,
    "high": 0.0000153,
    "close": 0.0000152,
    "volume": 61980713
  },
  {
    "date": "2025-12-04 10:00:00",
    "open": 0.0000152,
    "low": 0.0000151,
    "high": 0.0000178,
    "close": 0.0000169,
    "volume": 177983082
  },
  {
    "date": "2025-12-04 11:00:00",
    "open": 0.0000169,
    "low": 0.0000125,
    "high": 0.0000173,
    "close": 0.0000151,
    "volume": 108738648
  },
  {
    "date": "2025-12-04 12:00:00",
    "open": 0.0000151,
    "low": 0.0000149,
    "high": 0.0000151,
    "close": 0.000015,
    "volume": 54020798
  },
  {
    "date": "2025-12-04 13:00:00",
    "open": 0.000015,
    "low": 0.0000142,
    "high": 0.0000154,
    "close": 0.0000146,
    "volume": 77852434
  },
  {
    "date": "2025-12-04 14:00:00",
    "open": 0.0000146,
    "low": 0.0000143,
    "high": 0.0000152,
    "close": 0.0000148,
    "volume": 51839331
  },
  {
    "date": "2025-12-04 15:00:00",
    "open": 0.0000148,
    "low": 0.0000144,
    "high": 0.0000152,
    "close": 0.0000145,
    "volume": 40121345
  },
  {
    "date": "2025-12-04 16:00:00",
    "open": 0.0000145,
    "low": 0.0000144,
    "high": 0.0000147,
    "close": 0.0000146,
    "volume": 170646896
  },
  {
    "date": "2025-12-04 17:00:00",
    "open": 0.0000146,
    "low": 0.0000143,
    "high": 0.0000148,
    "close": 0.0000144,
    "volume": 63925059
  },
  {
    "date": "2025-12-04 18:00:00",
    "open": 0.0000144,
    "low": 0.0000144,
    "high": 0.0000144,
    "close": 0.0000144,
    "volume": 57379326
  },
  {
    "date": "2025-12-04 19:00:00",
    "open": 0.0000144,
    "low": 0.0000144,
    "high": 0.0000144,
    "close": 0.0000144,
    "volume": 46564621
  },
  {
    "date": "2025-12-04 20:00:00",
    "open": 0.0000144,
    "low": 0.000014,
    "high": 0.0000147,
    "close": 0.0000142,
    "volume": 60472416
  },
  {
    "date": "2025-12-04 21:00:00",
    "open": 0.0000142,
    "low": 0.0000141,
    "high": 0.0000144,
    "close": 0.0000143,
    "volume": 46915538
  },
  {
    "date": "2025-12-04 22:00:00",
    "open": 0.0000143,
    "low": 0.0000141,
    "high": 0.0000145,
    "close": 0.0000144,
    "volume": 88188058
  },
  {
    "date": "2025-12-04 23:00:00",
    "open": 0.0000144,
    "low": 0.0000144,
    "high": 0.0000144,
    "close": 0.0000144,
    "volume": 61730399
  },
  {
    "date": "2025-12-05 00:00:00",
    "open": 0.0000144,
    "low": 0.0000144,
    "high": 0.0000144,
    "close": 0.0000144,
    "volume": 54622354
  },
  {
    "date": "2025-12-05 01:00:00",
    "open": 0.0000144,
    "low": 0.0000144,
    "high": 0.0000144,
    "close": 0.0000144,
    "volume": 52482062
  },
  {
    "date": "2025-12-05 02:00:00",
    "open": 0.0000144,
    "low": 0.000014,
    "high": 0.0000146,
    "close": 0.0000142,
    "volume": 50317733
  },
  {
    "date": "2025-12-05 03:00:00",
    "open": 0.0000142,
    "low": 0.0000135,
    "high": 0.000016,
    "close": 0.0000149,
    "volume": 129415039
  },
  {
    "date": "2025-12-05 04:00:00",
    "open": 0.0000149,
    "low": 0.0000148,
    "high": 0.0000151,
    "close": 0.000015,
    "volume": 46155750
  },
  {
    "date": "2025-12-05 05:00:00",
    "open": 0.000015,
    "low": 0.000015,
    "high": 0.0000153,
    "close": 0.0000151,
    "volume": 56100055
  },
  {
    "date": "2025-12-05 06:00:00",
    "open": 0.0000151,
    "low": 0.0000147,
    "high": 0.0000152,
    "close": 0.0000149,
    "volume": 51005751
  },
  {
    "date": "2025-12-05 07:00:00",
    "open": 0.0000149,
    "low": 0.0000144,
    "high": 0.0000157,
    "close": 0.0000145,
    "volume": 93548961
  },
  {
    "date": "2025-12-05 08:00:00",
    "open": 0.0000145,
    "low": 0.0000143,
    "high": 0.0000147,
    "close": 0.0000146,
    "volume": 61802310
  },
  {
    "date": "2025-12-05 09:00:00",
    "open": 0.0000146,
    "low": 0.0000129,
    "high": 0.0000168,
    "close": 0.0000158,
    "volume": 149221507
  },
  {
    "date": "2025-12-05 10:00:00",
    "open": 0.0000158,
    "low": 0.0000127,
    "high": 0.0000179,
    "close": 0.0000175,
    "volume": 160862713
  },
  {
    "date": "2025-12-05 11:00:00",
    "open": 0.0000175,
    "low": 0.000017,
    "high": 0.0000176,
    "close": 0.0000172,
    "volume": 45035881
  },
  {
    "date": "2025-12-05 12:00:00",
    "open": 0.0000172,
    "low": 0.000017,
    "high": 0.0000176,
    "close": 0.0000174,
    "volume": 46311541
  },
  {
    "date": "2025-12-05 13:00:00",
    "open": 0.0000174,
    "low": 0.0000169,
    "high": 0.0000183,
    "close": 0.0000177,
    "volume": 60275476
  },
  {
    "date": "2025-12-05 14:00:00",
    "open": 0.0000177,
    "low": 0.0000174,
    "high": 0.0000181,
    "close": 0.0000175,
    "volume": 59645891
  },
  {
    "date": "2025-12-05 15:00:00",
    "open": 0.0000175,
    "low": 0.0000172,
    "high": 0.0000177,
    "close": 0.0000173,
    "volume": 46837157
  },
  {
    "date": "2025-12-05 16:00:00",
    "open": 0.0000173,
    "low": 0.000017,
    "high": 0.0000173,
    "close": 0.0000172,
    "volume": 48416932
  },
  {
    "date": "2025-12-05 17:00:00",
    "open": 0.0000172,
    "low": 0.000017,
    "high": 0.0000178,
    "close": 0.0000175,
    "volume": 60123976
  },
  {
    "date": "2025-12-05 18:00:00",
    "open": 0.0000175,
    "low": 0.0000139,
    "high": 0.0000236,
    "close": 0.0000197,
    "volume": 149504212
  },
  {
    "date": "2025-12-05 19:00:00",
    "open": 0.0000197,
    "low": 0.0000195,
    "high": 0.0000199,
    "close": 0.0000196,
    "volume": 40414826
  },
  {
    "date": "2025-12-05 20:00:00",
    "open": 0.0000196,
    "low": 0.0000196,
    "high": 0.0000201,
    "close": 0.0000199,
    "volume": 44326598
  },
  {
    "date": "2025-12-05 21:00:00",
    "open": 0.0000199,
    "low": 0.0000152,
    "high": 0.0000239,
    "close": 0.0000168,
    "volume": 189301203
  },
  {
    "date": "2025-12-05 22:00:00",
    "open": 0.0000168,
    "low": 0.0000163,
    "high": 0.0000171,
    "close": 0.0000166,
    "volume": 45878138
  },
  {
    "date": "2025-12-05 23:00:00",
    "open": 0.0000166,
    "low": 0.0000163,
    "high": 0.0000169,
    "close": 0.0000164,
    "volume": 46304326
  },
  {
    "date": "2025-12-06 00:00:00",
    "open": 0.0000164,
    "low": 0.000016,
    "high": 0.0000167,
    "close": 0.0000162,
    "volume": 57219014
  },
  {
    "date": "2025-12-06 01:00:00",
    "open": 0.0000162,
    "low": 0.0000162,
    "high": 0.0000162,
    "close": 0.0000162,
    "volume": 57726632
  },
  {
    "date": "2025-12-06 02:00:00",
    "open": 0.0000162,
    "low": 0.0000162,
    "high": 0.0000162,
    "close": 0.0000162,
    "volume": 50569412
  },
  {
    "date": "2025-12-06 03:00:00",
    "open": 0.0000162,
    "low": 0.0000159,
    "high": 0.0000166,
    "close": 0.0000164,
    "volume": 48694835
  },
  {
    "date": "2025-12-06 04:00:00",
    "open": 0.0000164,
    "low": 0.0000162,
    "high": 0.0000166,
    "close": 0.0000163,
    "volume": 63874073
  },
  {
    "date": "2025-12-06 05:00:00",
    "open": 0.0000163,
    "low": 0.0000158,
    "high": 0.0000167,
    "close": 0.0000161,
    "volume": 44760919
  },
  {
    "date": "2025-12-06 06:00:00",
    "open": 0.0000161,
    "low": 0.000016,
    "high": 0.0000163,
    "close": 0.0000162,
    "volume": 58916504
  },
  {
    "date": "2025-12-06 07:00:00",
    "open": 0.0000162,
    "low": 0.0000161,
    "high": 0.0000168,
    "close": 0.0000164,
    "volume": 43085109
  },
  {
    "date": "2025-12-06 08:00:00",
    "open": 0.0000164,
    "low": 0.0000161,
    "high": 0.0000172,
    "close": 0.0000167,
    "volume": 56098777
  },
  {
    "date": "2025-12-06 09:00:00",
    "open": 0.0000167,
    "low": 0.0000165,
    "high": 0.0000176,
    "close": 0.000017,
    "volume": 63376376
  },
  {
    "date": "2025-12-06 10:00:00",
    "open": 0.000017,
    "low": 0.0000168,
    "high": 0.0000171,
    "close": 0.0000169,
    "volume": 54911167
  },
  {
    "date": "2025-12-06 11:00:00",
    "open": 0.0000169,
    "low": 0.0000166,
    "high": 0.0000177,
    "close": 0.0000172,
    "volume": 40577558
  },
  {
    "date": "2025-12-06 12:00:00",
    "open": 0.0000172,
    "low": 0.0000163,
    "high": 0.0000175,
    "close": 0.0000169,
    "volume": 58749303
  },
  {
    "date": "2025-12-06 13:00:00",
    "open": 0.0000169,
    "low": 0.0000169,
    "high": 0.0000169,
    "close": 0.0000169,
    "volume": 62231983
  },
  {
    "date": "2025-12-06 14:00:00",
    "open": 0.0000169,
    "low": 0.0000167,
    "high": 0.0000172,
    "close": 0.000017,
    "volume": 62574606
  },
  {
    "date": "2025-12-06 15:00:00",
    "open": 0.000017,
    "low": 0.0000168,
    "high": 0.0000175,
    "close": 0.0000172,
    "volume": 49706654
  },
  {
    "date": "2025-12-06 16:00:00",
    "open": 0.0000172,
    "low": 0.0000172,
    "high": 0.0000173,
    "close": 0.0000173,
    "volume": 56964503
  },
  {
    "date": "2025-12-06 17:00:00",
    "open": 0.0000173,
    "low": 0.000017,
    "high": 0.0000174,
    "close": 0.0000172,
    "volume": 45236796
  },
  {
    "date": "2025-12-06 18:00:00",
    "open": 0.0000172,
    "low": 0.0000165,
    "high": 0.0000177,
    "close": 0.0000169,
    "volume": 47975686
  },
  {
    "date": "2025-12-06 19:00:00",
    "open": 0.0000169,
    "low": 0.0000165,
    "high": 0.0000174,
    "close": 0.0000171,
    "volume": 41339532
  },
  {
    "date": "2025-12-06 20:00:00",
    "open": 0.0000171,
    "low": 0.0000168,
    "high": 0.0000172,
    "close": 0.000017,
    "volume": 64570707
  },
  {
    "date": "2025-12-06 21:00:00",
    "open": 0.000017,
    "low": 0.000017,
    "high": 0.000017,
    "close": 0.000017,
    "volume": 41027973
  },
  {
    "date": "2025-12-06 22:00:00",
    "open": 0.000017,
    "low": 0.0000166,
    "high": 0.0000171,
    "close": 0.0000167,
    "volume": 48704180
  },
  {
    "date": "2025-12-06 23:00:00",
    "open": 0.0000167,
    "low": 0.0000164,
    "high": 0.0000169,
    "close": 0.0000165,
    "volume": 47326922
  },
  {
    "date": "2025-12-07 00:00:00",
    "open": 0.0000165,
    "low": 0.0000165,
    "high": 0.0000168,
    "close": 0.0000167,
    "volume": 58738600
  },
  {
    "date": "2025-12-07 01:00:00",
    "open": 0.0000167,
    "low": 0.0000167,
    "high": 0.0000167,
    "close": 0.0000167,
    "volume": 49409869
  },
  {
    "date": "2025-12-07 02:00:00",
    "open": 0.0000167,
    "low": 0.000016,
    "high": 0.0000172,
    "close": 0.0000164,
    "volume": 57290669
  },
  {
    "date": "2025-12-07 03:00:00",
    "open": 0.0000164,
    "low": 0.0000164,
    "high": 0.0000164,
    "close": 0.0000164,
    "volume": 45969808
  },
  {
    "date": "2025-12-07 04:00:00",
    "open": 0.0000164,
    "low": 0.0000158,
    "high": 0.000017,
    "close": 0.0000167,
    "volume": 52281129
  },
  {
    "date": "2025-12-07 05:00:00",
    "open": 0.0000167,
    "low": 0.0000166,
    "high": 0.0000201,
    "close": 0.0000179,
    "volume": 141774000
  },
  {
    "date": "2025-12-07 06:00:00",
    "open": 0.0000179,
    "low": 0.000013,
    "high": 0.0000194,
    "close": 0.0000159,
    "volume": 148729151
  },
  {
    "date": "2025-12-07 07:00:00",
    "open": 0.0000159,
    "low": 0.0000157,
    "high": 0.0000162,
    "close": 0.000016,
    "volume": 50213933
  },
  {
    "date": "2025-12-07 08:00:00",
    "open": 0.000016,
    "low": 0.000016,
    "high": 0.000016,
    "close": 0.000016,
    "volume": 40787798
  },
  {
    "date": "2025-12-07 09:00:00",
    "open": 0.000016,
    "low": 0.000016,
    "high": 0.000016,
    "close": 0.000016,
    "volume": 56411678
  },
  {
    "date": "2025-12-07 10:00:00",
    "open": 0.000016,
    "low": 0.0000158,
    "high": 0.000018,
    "close": 0.0000167,
    "volume": 138908785
  },
  {
    "date": "2025-12-07 11:00:00",
    "open": 0.0000167,
    "low": 0.0000164,
    "high": 0.0000173,
    "close": 0.000017,
    "volume": 69649640
  },
  {
    "date": "2025-12-07 12:00:00",
    "open": 0.000017,
    "low": 0.0000166,
    "high": 0.0000177,
    "close": 0.0000173,
    "volume": 104372331
  },
  {
    "date": "2025-12-07 13:00:00",
    "open": 0.0000173,
    "low": 0.000017,
    "high": 0.0000176,
    "close": 0.0000171,
    "volume": 55326984
  },
  {
    "date": "2025-12-07 14:00:00",
    "open": 0.0000171,
    "low": 0.000017,
    "high": 0.0000173,
    "close": 0.0000172,
    "volume": 118731844
  },
  {
    "date": "2025-12-07 15:00:00",
    "open": 0.0000172,
    "low": 0.0000172,
    "high": 0.0000172,
    "close": 0.0000172,
    "volume": 53886343
  },
  {
    "date": "2025-12-07 16:00:00",
    "open": 0.0000172,
    "low": 0.0000166,
    "high": 0.0000176,
    "close": 0.0000169,
    "volume": 40899833
  },
  {
    "date": "2025-12-07 17:00:00",
    "open": 0.0000169,
    "low": 0.0000164,
    "high": 0.0000174,
    "close": 0.0000166,
    "volume": 61142260
  },
  {
    "date": "2025-12-07 18:00:00",
    "open": 0.0000166,
    "low": 0.0000166,
    "high": 0.0000166,
    "close": 0.0000166,
    "volume": 45572912
  },
  {
    "date": "2025-12-07 19:00:00",
    "open": 0.0000166,
    "low": 0.0000164,
    "high": 0.0000166,
    "close": 0.0000165,
    "volume": 45027980
  },
  {
    "date": "2025-12-07 20:00:00",
    "open": 0.0000165,
    "low": 0.0000162,
    "high": 0.0000166,
    "close": 0.0000163,
    "volume": 56407581
  },
  {
    "date": "2025-12-07 21:00:00",
    "open": 0.0000163,
    "low": 0.0000108,
    "high": 0.0000171,
    "close": 0.0000141,
    "volume": 144472650
  },
  {
    "date": "2025-12-07 22:00:00",
    "open": 0.0000141,
    "low": 0.0000138,
    "high": 0.0000142,
    "close": 0.0000139,
    "volume": 57575255
  },
  {
    "date": "2025-12-07 23:00:00",
    "open": 0.0000139,
    "low": 0.0000113,
    "high": 0.0000149,
    "close": 0.0000129,
    "volume": 137139569
  },
  {
    "date": "2025-12-08 00:00:00",
    "open": 0.0000129,
    "low": 0.0000126,
    "high": 0.0000131,
    "close": 0.0000127,
    "volume": 49483294
  },
  {
    "date": "2025-12-08 01:00:00",
    "open": 0.0000127,
    "low": 0.0000125,
    "high": 0.0000132,
    "close": 0.0000129,
    "volume": 57717819
  },
  {
    "date": "2025-12-08 02:00:00",
    "open": 0.0000129,
    "low": 0.0000128,
    "high": 0.0000131,
    "close": 0.000013,
    "volume": 54912540
  },
  {
    "date": "2025-12-08 03:00:00",
    "open": 0.000013,
    "low": 0.000013,
    "high": 0.000013,
    "close": 0.000013,
    "volume": 58664946
  },
  {
    "date": "2025-12-08 04:00:00",
    "open": 0.000013,
    "low": 0.0000127,
    "high": 0.0000133,
    "close": 0.0000132,
    "volume": 49191060
  },
  {
    "date": "2025-12-08 05:00:00",
    "open": 0.0000132,
    "low": 0.0000129,
    "high": 0.0000133,
    "close": 0.0000131,
    "volume": 41835321
  },
  {
    "date": "2025-12-08 06:00:00",
    "open": 0.0000131,
    "low": 0.0000131,
    "high": 0.0000134,
    "close": 0.0000132,
    "volume": 67287175
  },
  {
    "date": "2025-12-08 07:00:00",
    "open": 0.0000132,
    "low": 0.0000126,
    "high": 0.0000134,
    "close": 0.000013,
    "volume": 51937413
  },
  {
    "date": "2025-12-08 08:00:00",
    "open": 0.000013,
    "low": 0.000013,
    "high": 0.000013,
    "close": 0.000013,
    "volume": 44597950
  },
  {
    "date": "2025-12-08 09:00:00",
    "open": 0.000013,
    "low": 0.0000128,
    "high": 0.0000132,
    "close": 0.0000129,
    "volume": 56877240
  },
  {
    "date": "2025-12-08 10:00:00",
    "open": 0.0000129,
    "low": 0.000012,
    "high": 0.0000147,
    "close": 0.0000138,
    "volume": 134253802
  },
  {
    "date": "2025-12-08 11:00:00",
    "open": 0.0000138,
    "low": 0.0000138,
    "high": 0.0000138,
    "close": 0.0000138,
    "volume": 52033027
  },
  {
    "date": "2025-12-08 12:00:00",
    "open": 0.0000138,
    "low": 0.0000134,
    "high": 0.0000145,
    "close": 0.0000141,
    "volume": 49935413
  },
  {
    "date": "2025-12-08 13:00:00",
    "open": 0.0000141,
    "low": 0.0000139,
    "high": 0.0000142,
    "close": 0.000014,
    "volume": 53676254
  },
  {
    "date": "2025-12-08 14:00:00",
    "open": 0.000014,
    "low": 0.0000136,
    "high": 0.0000144,
    "close": 0.0000142,
    "volume": 58572346
  },
  {
    "date": "2025-12-08 15:00:00",
    "open": 0.0000142,
    "low": 0.0000138,
    "high": 0.0000145,
    "close": 0.000014,
    "volume": 47324751
  },
  {
    "date": "2025-12-08 16:00:00",
    "open": 0.000014,
    "low": 0.000014,
    "high": 0.0000143,
    "close": 0.0000141,
    "volume": 62160161
  },
  {
    "date": "2025-12-08 17:00:00",
    "open": 0.0000141,
    "low": 0.000014,
    "high": 0.0000143,
    "close": 0.0000142,
    "volume": 58930700
  },
  {
    "date": "2025-12-08 18:00:00",
    "open": 0.0000142,
    "low": 0.0000141,
    "high": 0.0000144,
    "close": 0.0000141,
    "volume": 63301438
  },
  {
    "date": "2025-12-08 19:00:00",
    "open": 0.0000141,
    "low": 0.0000141,
    "high": 0.0000141,
    "close": 0.0000141,
    "volume": 41773349
  },
  {
    "date": "2025-12-08 20:00:00",
    "open": 0.0000141,
    "low": 0.000014,
    "high": 0.0000143,
    "close": 0.0000142,
    "volume": 62096715
  },
  {
    "date": "2025-12-08 21:00:00",
    "open": 0.0000142,
    "low": 0.0000139,
    "high": 0.0000145,
    "close": 0.000014,
    "volume": 63638928
  },
  {
    "date": "2025-12-08 22:00:00",
    "open": 0.000014,
    "low": 0.0000137,
    "high": 0.0000144,
    "close": 0.0000138,
    "volume": 48032131
  },
  {
    "date": "2025-12-08 23:00:00",
    "open": 0.0000138,
    "low": 0.0000136,
    "high": 0.0000139,
    "close": 0.0000136,
    "volume": 47994688
  },
  {
    "date": "2025-12-09 00:00:00",
    "open": 0.0000136,
    "low": 0.0000135,
    "high": 0.0000144,
    "close": 0.0000139,
    "volume": 143840579
  },
  {
    "date": "2025-12-09 01:00:00",
    "open": 0.0000139,
    "low": 0.0000139,
    "high": 0.0000141,
    "close": 0.000014,
    "volume": 62690093
  },
  {
    "date": "2025-12-09 02:00:00",
    "open": 0.000014,
    "low": 0.0000137,
    "high": 0.0000141,
    "close": 0.0000138,
    "volume": 61050960
  },
  {
    "date": "2025-12-09 03:00:00",
    "open": 0.0000138,
    "low": 0.0000138,
    "high": 0.0000138,
    "close": 0.0000138,
    "volume": 55342842
  },
  {
    "date": "2025-12-09 04:00:00",
    "open": 0.0000138,
    "low": 0.0000137,
    "high": 0.0000139,
    "close": 0.0000139,
    "volume": 43595131
  },
  {
    "date": "2025-12-09 05:00:00",
    "open": 0.0000139,
    "low": 0.0000138,
    "high": 0.0000144,
    "close": 0.0000141,
    "volume": 41980221
  },
  {
    "date": "2025-12-09 06:00:00",
    "open": 0.0000141,
    "low": 0.0000137,
    "high": 0.0000148,
    "close": 0.0000144,
    "volume": 53073157
  },
  {
    "date": "2025-12-09 07:00:00",
    "open": 0.0000144,
    "low": 0.000014,
    "high": 0.0000152,
    "close": 0.0000147,
    "volume": 48667660
  },
  {
    "date": "2025-12-09 08:00:00",
    "open": 0.0000147,
    "low": 0.0000143,
    "high": 0.0000148,
    "close": 0.0000145,
    "volume": 42337532
  },
  {
    "date": "2025-12-09 09:00:00",
    "open": 0.0000145,
    "low": 0.0000139,
    "high": 0.0000148,
    "close": 0.0000143,
    "volume": 57536279
  },
  {
    "date": "2025-12-09 10:00:00",
    "open": 0.0000143,
    "low": 0.0000143,
    "high": 0.0000143,
    "close": 0.0000143,
    "volume": 55218756
  },
  {
    "date": "2025-12-09 11:00:00",
    "open": 0.0000143,
    "low": 0.0000141,
    "high": 0.0000145,
    "close": 0.0000142,
    "volume": 63510069
  },
  {
    "date": "2025-12-09 12:00:00",
    "open": 0.0000142,
    "low": 0.0000136,
    "high": 0.0000146,
    "close": 0.0000145,
    "volume": 46138834
  },
  {
    "date": "2025-12-09 13:00:00",
    "open": 0.0000145,
    "low": 0.0000143,
    "high": 0.0000147,
    "close": 0.0000146,
    "volume": 59565369
  },
  {
    "date": "2025-12-09 14:00:00",
    "open": 0.0000146,
    "low": 0.0000142,
    "high": 0.0000148,
    "close": 0.0000144,
    "volume": 40398875
  },
  {
    "date": "2025-12-09 15:00:00",
    "open": 0.0000144,
    "low": 0.0000141,
    "high": 0.0000148,
    "close": 0.0000142,
    "volume": 58732901
  },
  {
    "date": "2025-12-09 16:00:00",
    "open": 0.0000142,
    "low": 0.0000137,
    "high": 0.0000145,
    "close": 0.000014,
    "volume": 40994688
  },
  {
    "date": "2025-12-09 17:00:00",
    "open": 0.000014,
    "low": 0.0000137,
    "high": 0.0000141,
    "close": 0.0000139,
    "volume": 43310610
  },
  {
    "date": "2025-12-09 18:00:00",
    "open": 0.0000139,
    "low": 0.0000139,
    "high": 0.0000139,
    "close": 0.0000139,
    "volume": 42414188
  },
  {
    "date": "2025-12-09 19:00:00",
    "open": 0.0000139,
    "low": 0.0000139,
    "high": 0.0000139,
    "close": 0.0000139,
    "volume": 62216080
  },
  {
    "date": "2025-12-09 20:00:00",
    "open": 0.0000139,
    "low": 0.0000111,
    "high": 0.0000149,
    "close": 0.0000123,
    "volume": 172820121
  },
  {
    "date": "2025-12-09 21:00:00",
    "open": 0.0000123,
    "low": 0.0000123,
    "high": 0.0000123,
    "close": 0.0000123,
    "volume": 61935560
  },
  {
    "date": "2025-12-09 22:00:00",
    "open": 0.0000123,
    "low": 0.0000121,
    "high": 0.0000125,
    "close": 0.0000122,
    "volume": 55242229
  },
  {
    "date": "2025-12-09 23:00:00",
    "open": 0.0000122,
    "low": 0.0000122,
    "high": 0.0000122,
    "close": 0.0000122,
    "volume": 51228538
  },
  {
    "date": "2025-12-10 00:00:00",
    "open": 0.0000122,
    "low": 0.0000117,
    "high": 0.0000125,
    "close": 0.000012,
    "volume": 60845469
  },
  {
    "date": "2025-12-10 01:00:00",
    "open": 0.000012,
    "low": 0.0000116,
    "high": 0.0000123,
    "close": 0.0000122,
    "volume": 47785599
  },
  {
    "date": "2025-12-10 02:00:00",
    "open": 0.0000122,
    "low": 0.0000093,
    "high": 0.0000148,
    "close": 0.0000137,
    "volume": 161109549
  },
  {
    "date": "2025-12-10 03:00:00",
    "open": 0.0000137,
    "low": 0.0000134,
    "high": 0.000014,
    "close": 0.0000139,
    "volume": 51481826
  },
  {
    "date": "2025-12-10 04:00:00",
    "open": 0.0000139,
    "low": 0.0000135,
    "high": 0.0000142,
    "close": 0.0000137,
    "volume": 55126349
  },
  {
    "date": "2025-12-10 05:00:00",
    "open": 0.0000137,
    "low": 0.0000137,
    "high": 0.0000137,
    "close": 0.0000137,
    "volume": 62423596
  },
  {
    "date": "2025-12-10 06:00:00",
    "open": 0.0000137,
    "low": 0.000013,
    "high": 0.0000148,
    "close": 0.0000141,
    "volume": 164787734
  },
  {
    "date": "2025-12-10 07:00:00",
    "open": 0.0000141,
    "low": 0.0000114,
    "high": 0.0000166,
    "close": 0.0000126,
    "volume": 170953704
  },
  {
    "date": "2025-12-10 08:00:00",
    "open": 0.0000126,
    "low": 0.0000126,
    "high": 0.0000126,
    "close": 0.0000126,
    "volume": 40032590
  },
  {
    "date": "2025-12-10 09:00:00",
    "open": 0.0000126,
    "low": 0.0000123,
    "high": 0.0000126,
    "close": 0.0000125,
    "volume": 52698055
  },
  {
    "date": "2025-12-10 10:00:00",
    "open": 0.0000125,
    "low": 0.000012,
    "high": 0.0000126,
    "close": 0.0000123,
    "volume": 42329105
  },
  {
    "date": "2025-12-10 11:00:00",
    "open": 0.0000123,
    "low": 0.0000121,
    "high": 0.0000125,
    "close": 0.0000121,
    "volume": 43123857
  },
  {
    "date": "2025-12-10 12:00:00",
    "open": 0.0000121,
    "low": 0.000012,
    "high": 0.0000123,
    "close": 0.0000122,
    "volume": 43252330
  },
  {
    "date": "2025-12-10 13:00:00",
    "open": 0.0000122,
    "low": 0.0000117,
    "high": 0.0000126,
    "close": 0.000012,
    "volume": 43899561
  },
  {
    "date": "2025-12-10 14:00:00",
    "open": 0.000012,
    "low": 0.0000118,
    "high": 0.000012,
    "close": 0.0000119,
    "volume": 59391703
  },
  {
    "date": "2025-12-10 15:00:00",
    "open": 0.0000119,
    "low": 0.0000119,
    "high": 0.0000119,
    "close": 0.0000119,
    "volume": 63272045
  },
  {
    "date": "2025-12-10 16:00:00",
    "open": 0.0000119,
    "low": 0.0000114,
    "high": 0.000012,
    "close": 0.0000117,
    "volume": 52485048
  },
  {
    "date": "2025-12-10 17:00:00",
    "open": 0.0000117,
    "low": 0.0000113,
    "high": 0.0000122,
    "close": 0.0000119,
    "volume": 58669216
  },
  {
    "date": "2025-12-10 18:00:00",
    "open": 0.0000119,
    "low": 0.0000119,
    "high": 0.0000119,
    "close": 0.0000119,
    "volume": 51174669
  },
  {
    "date": "2025-12-10 19:00:00",
    "open": 0.0000119,
    "low": 0.0000117,
    "high": 0.000012,
    "close": 0.0000118,
    "volume": 53914145
  },
  {
    "date": "2025-12-10 20:00:00",
    "open": 0.0000118,
    "low": 0.0000118,
    "high": 0.0000118,
    "close": 0.0000118,
    "volume": 62603948
  },
  {
    "date": "2025-12-10 21:00:00",
    "open": 0.0000118,
    "low": 0.0000118,
    "high": 0.000012,
    "close": 0.0000119,
    "volume": 59525183
  },
  {
    "date": "2025-12-10 22:00:00",
    "open": 0.0000119,
    "low": 0.0000119,
    "high": 0.0000119,
    "close": 0.0000119,
    "volume": 40648341
  },
  {
    "date": "2025-12-10 23:00:00",
    "open": 0.0000119,
    "low": 0.0000117,
    "high": 0.0000121,
    "close": 0.000012,
    "volume": 58214918
  },
  {
    "date": "2025-12-11 00:00:00",
    "open": 0.000012,
    "low": 0.0000115,
    "high": 0.0000126,
    "close": 0.0000123,
    "volume": 56793793
  },
  {
    "date": "2025-12-11 01:00:00",
    "open": 0.0000123,
    "low": 0.0000123,
    "high": 0.0000123,
    "close": 0.0000123,
    "volume": 47505663
  },
  {
    "date": "2025-12-11 02:00:00",
    "open": 0.0000123,
    "low": 0.0000123,
    "high": 0.0000125,
    "close": 0.0000125,
    "volume": 42165967
  },
  {
    "date": "2025-12-11 03:00:00",
    "open": 0.0000125,
    "low": 0.0000122,
    "high": 0.0000127,
    "close": 0.0000127,
    "volume": 153892782
  },
  {
    "date": "2025-12-11 04:00:00",
    "open": 0.0000127,
    "low": 0.0000125,
    "high": 0.0000128,
    "close": 0.0000126,
    "volume": 56214082
  },
  {
    "date": "2025-12-11 05:00:00",
    "open": 0.0000126,
    "low": 0.0000125,
    "high": 0.0000156,
    "close": 0.000014,
    "volume": 195951817
  },
  {
    "date": "2025-12-11 06:00:00",
    "open": 0.000014,
    "low": 0.0000138,
    "high": 0.000014,
    "close": 0.0000139,
    "volume": 62809058
  },
  {
    "date": "2025-12-11 07:00:00",
    "open": 0.0000139,
    "low": 0.0000137,
    "high": 0.0000147,
    "close": 0.0000142,
    "volume": 54829132
  },
  {
    "date": "2025-12-11 08:00:00",
    "open": 0.0000142,
    "low": 0.0000141,
    "high": 0.0000147,
    "close": 0.0000145,
    "volume": 52420473
  },
  {
    "date": "2025-12-11 09:00:00",
    "open": 0.0000145,
    "low": 0.0000143,
    "high": 0.0000146,
    "close": 0.0000144,
    "volume": 60434047
  },
  {
    "date": "2025-12-11 10:00:00",
    "open": 0.0000144,
    "low": 0.0000138,
    "high": 0.0000145,
    "close": 0.0000142,
    "volume": 61117005
  },
  {
    "date": "2025-12-11 11:00:00",
    "open": 0.0000142,
    "low": 0.0000142,
    "high": 0.0000142,
    "close": 0.0000142,
    "volume": 49422094
  },
  {
    "date": "2025-12-11 12:00:00",
    "open": 0.0000142,
    "low": 0.0000139,
    "high": 0.0000143,
    "close": 0.000014,
    "volume": 73593030
  },
  {
    "date": "2025-12-11 13:00:00",
    "open": 0.000014,
    "low": 0.0000137,
    "high": 0.0000141,
    "close": 0.0000138,
    "volume": 42913295
  },
  {
    "date": "2025-12-11 14:00:00",
    "open": 0.0000138,
    "low": 0.0000124,
    "high": 0.0000146,
    "close": 0.0000132,
    "volume": 117137383
  },
  {
    "date": "2025-12-11 15:00:00",
    "open": 0.0000132,
    "low": 0.000013,
    "high": 0.0000134,
    "close": 0.0000133,
    "volume": 56853517
  },
  {
    "date": "2025-12-11 16:00:00",
    "open": 0.0000133,
    "low": 0.0000133,
    "high": 0.0000133,
    "close": 0.0000133,
    "volume": 44808807
  },
  {
    "date": "2025-12-11 17:00:00",
    "open": 0.0000133,
    "low": 0.0000131,
    "high": 0.0000135,
    "close": 0.0000132,
    "volume": 53110482
  },
  {
    "date": "2025-12-11 18:00:00",
    "open": 0.0000132,
    "low": 0.0000127,
    "high": 0.0000135,
    "close": 0.0000129,
    "volume": 83756758
  },
  {
    "date": "2025-12-11 19:00:00",
    "open": 0.0000129,
    "low": 0.000012,
    "high": 0.0000133,
    "close": 0.0000126,
    "volume": 43653483
  },
  {
    "date": "2025-12-11 20:00:00",
    "open": 0.0000126,
    "low": 0.0000123,
    "high": 0.0000127,
    "close": 0.0000124,
    "volume": 60292707
  },
  {
    "date": "2025-12-11 21:00:00",
    "open": 0.0000124,
    "low": 0.0000123,
    "high": 0.0000126,
    "close": 0.0000125,
    "volume": 55947543
  },
  {
    "date": "2025-12-11 22:00:00",
    "open": 0.0000125,
    "low": 0.0000124,
    "high": 0.0000127,
    "close": 0.0000127,
    "volume": 40993211
  },
  {
    "date": "2025-12-11 23:00:00",
    "open": 0.0000127,
    "low": 0.0000123,
    "high": 0.0000144,
    "close": 0.0000133,
    "volume": 173100959
  },
  {
    "date": "2025-12-12 00:00:00",
    "open": 0.0000133,
    "low": 0.0000131,
    "high": 0.0000135,
    "close": 0.0000132,
    "volume": 46317793
  },
  {
    "date": "2025-12-12 01:00:00",
    "open": 0.0000132,
    "low": 0.0000132,
    "high": 0.0000134,
    "close": 0.0000133,
    "volume": 40110241
  },
  {
    "date": "2025-12-12 02:00:00",
    "open": 0.0000133,
    "low": 0.0000132,
    "high": 0.0000136,
    "close": 0.0000134,
    "volume": 55033608
  },
  {
    "date": "2025-12-12 03:00:00",
    "open": 0.0000134,
    "low": 0.0000132,
    "high": 0.0000135,
    "close": 0.0000133,
    "volume": 53567767
  },
  {
    "date": "2025-12-12 04:00:00",
    "open": 0.0000133,
    "low": 0.0000132,
    "high": 0.0000137,
    "close": 0.0000135,
    "volume": 43142111
  },
  {
    "date": "2025-12-12 05:00:00",
    "open": 0.0000135,
    "low": 0.0000132,
    "high": 0.000014,
    "close": 0.0000137,
    "volume": 50818149
  },
  {
    "date": "2025-12-12 06:00:00",
    "open": 0.0000137,
    "low": 0.0000132,
    "high": 0.0000137,
    "close": 0.0000135,
    "volume": 62133855
  },
  {
    "date": "2025-12-12 07:00:00",
    "open": 0.0000135,
    "low": 0.0000133,
    "high": 0.0000138,
    "close": 0.0000136,
    "volume": 63935199
  },
  {
    "date": "2025-12-12 08:00:00",
    "open": 0.0000136,
    "low": 0.0000124,
    "high": 0.0000144,
    "close": 0.0000132,
    "volume": 189506433
  },
  {
    "date": "2025-12-12 09:00:00",
    "open": 0.0000132,
    "low": 0.0000131,
    "high": 0.0000135,
    "close": 0.0000133,
    "volume": 47698117
  },
  {
    "date": "2025-12-12 10:00:00",
    "open": 0.0000133,
    "low": 0.000013,
    "high": 0.0000137,
    "close": 0.0000131,
    "volume": 55474300
  },
  {
    "date": "2025-12-12 11:00:00",
    "open": 0.0000131,
    "low": 0.0000106,
    "high": 0.0000134,
    "close": 0.0000118,
    "volume": 160103418
  },
  {
    "date": "2025-12-12 12:00:00",
    "open": 0.0000118,
    "low": 0.0000118,
    "high": 0.0000118,
    "close": 0.0000118,
    "volume": 51305576
  },
  {
    "date": "2025-12-12 13:00:00",
    "open": 0.0000118,
    "low": 0.0000111,
    "high": 0.0000129,
    "close": 0.0000122,
    "volume": 112810952
  },
  {
    "date": "2025-12-12 14:00:00",
    "open": 0.0000122,
    "low": 0.0000122,
    "high": 0.0000122,
    "close": 0.0000122,
    "volume": 60337517
  },
  {
    "date": "2025-12-12 15:00:00",
    "open": 0.0000122,
    "low": 0.0000121,
    "high": 0.0000122,
    "close": 0.0000121,
    "volume": 63540866
  },
  {
    "date": "2025-12-12 16:00:00",
    "open": 0.0000121,
    "low": 0.0000121,
    "high": 0.0000121,
    "close": 0.0000121,
    "volume": 49767195
  },
  {
    "date": "2025-12-12 17:00:00",
    "open": 0.0000121,
    "low": 0.0000121,
    "high": 0.0000121,
    "close": 0.0000121,
    "volume": 56198573
  },
  {
    "date": "2025-12-12 18:00:00",
    "open": 0.0000121,
    "low": 0.0000118,
    "high": 0.0000123,
    "close": 0.0000119,
    "volume": 61744448
  },
  {
    "date": "2025-12-12 19:00:00",
    "open": 0.0000119,
    "low": 0.0000119,
    "high": 0.0000119,
    "close": 0.0000119,
    "volume": 63229938
  },
  {
    "date": "2025-12-12 20:00:00",
    "open": 0.0000119,
    "low": 0.0000117,
    "high": 0.0000122,
    "close": 0.0000121,
    "volume": 77747089
  },
  {
    "date": "2025-12-12 21:00:00",
    "open": 0.0000121,
    "low": 0.0000119,
    "high": 0.0000124,
    "close": 0.0000122,
    "volume": 40825167
  },
  {
    "date": "2025-12-12 22:00:00",
    "open": 0.0000122,
    "low": 0.0000117,
    "high": 0.0000125,
    "close": 0.000012,
    "volume": 55557968
  },
  {
    "date": "2025-12-12 23:00:00",
    "open": 0.000012,
    "low": 0.000012,
    "high": 0.000012,
    "close": 0.000012,
    "volume": 57841839
  },
  {
    "date": "2025-12-13 00:00:00",
    "open": 0.000012,
    "low": 0.0000116,
    "high": 0.0000123,
    "close": 0.0000118,
    "volume": 51922031
  },
  {
    "date": "2025-12-13 01:00:00",
    "open": 0.0000118,
    "low": 0.0000114,
    "high": 0.0000125,
    "close": 0.0000121,
    "volume": 123758017
  },
  {
    "date": "2025-12-13 02:00:00",
    "open": 0.0000121,
    "low": 0.000012,
    "high": 0.0000121,
    "close": 0.000012,
    "volume": 40827653
  },
  {
    "date": "2025-12-13 03:00:00",
    "open": 0.000012,
    "low": 0.000012,
    "high": 0.000012,
    "close": 0.000012,
    "volume": 61806441
  },
  {
    "date": "2025-12-13 04:00:00",
    "open": 0.000012,
    "low": 0.000012,
    "high": 0.0000125,
    "close": 0.0000122,
    "volume": 178515876
  },
  {
    "date": "2025-12-13 05:00:00",
    "open": 0.0000122,
    "low": 0.0000122,
    "high": 0.0000125,
    "close": 0.0000123,
    "volume": 58690537
  },
  {
    "date": "2025-12-13 06:00:00",
    "open": 0.0000123,
    "low": 0.0000122,
    "high": 0.0000125,
    "close": 0.0000124,
    "volume": 44540604
  },
  {
    "date": "2025-12-13 07:00:00",
    "open": 0.0000124,
    "low": 0.0000119,
    "high": 0.0000128,
    "close": 0.0000122,
    "volume": 50446743
  },
  {
    "date": "2025-12-13 08:00:00",
    "open": 0.0000122,
    "low": 0.0000119,
    "high": 0.0000125,
    "close": 0.000012,
    "volume": 54681432
  },
  {
    "date": "2025-12-13 09:00:00",
    "open": 0.000012,
    "low": 0.0000113,
    "high": 0.0000131,
    "close": 0.0000113,
    "volume": 138127515
  },
  {
    "date": "2025-12-13 10:00:00",
    "open": 0.0000113,
    "low": 0.0000111,
    "high": 0.0000116,
    "close": 0.0000111,
    "volume": 49961020
  },
  {
    "date": "2025-12-13 11:00:00",
    "open": 0.0000111,
    "low": 0.0000109,
    "high": 0.0000113,
    "close": 0.0000112,
    "volume": 60971433
  },
  {
    "date": "2025-12-13 12:00:00",
    "open": 0.0000112,
    "low": 0.0000108,
    "high": 0.0000114,
    "close": 0.0000114,
    "volume": 48333390
  },
  {
    "date": "2025-12-13 13:00:00",
    "open": 0.0000114,
    "low": 0.0000111,
    "high": 0.0000119,
    "close": 0.0000116,
    "volume": 47690043
  },
  {
    "date": "2025-12-13 14:00:00",
    "open": 0.0000116,
    "low": 0.0000115,
    "high": 0.0000118,
    "close": 0.0000115,
    "volume": 61153993
  },
  {
    "date": "2025-12-13 15:00:00",
    "open": 0.0000115,
    "low": 0.0000115,
    "high": 0.0000115,
    "close": 0.0000115,
    "volume": 62769309
  },
  {
    "date": "2025-12-13 16:00:00",
    "open": 0.0000115,
    "low": 0.0000113,
    "high": 0.0000116,
    "close": 0.0000114,
    "volume": 53225461
  },
  {
    "date": "2025-12-13 17:00:00",
    "open": 0.0000114,
    "low": 0.0000087,
    "high": 0.0000127,
    "close": 0.0000099,
    "volume": 152454335
  },
  {
    "date": "2025-12-13 18:00:00",
    "open": 0.0000099,
    "low": 0.0000099,
    "high": 0.0000099,
    "close": 0.0000099,
    "volume": 64476926
  },
  {
    "date": "2025-12-13 19:00:00",
    "open": 0.0000099,
    "low": 0.0000097,
    "high": 0.00001,
    "close": 0.0000098,
    "volume": 52515753
  },
  {
    "date": "2025-12-13 20:00:00",
    "open": 0.0000098,
    "low": 0.0000094,
    "high": 0.0000109,
    "close": 0.0000102,
    "volume": 112966620
  },
  {
    "date": "2025-12-13 21:00:00",
    "open": 0.0000102,
    "low": 0.0000099,
    "high": 0.0000102,
    "close": 0.0000101,
    "volume": 59338460
  },
  {
    "date": "2025-12-13 22:00:00",
    "open": 0.0000101,
    "low": 0.0000099,
    "high": 0.0000103,
    "close": 0.00001,
    "volume": 59914661
  },
  {
    "date": "2025-12-13 23:00:00",
    "open": 0.00001,
    "low": 0.0000096,
    "high": 0.0000105,
    "close": 0.0000102,
    "volume": 48456382
  },
  {
    "date": "2025-12-14 00:00:00",
    "open": 0.0000102,
    "low": 0.0000101,
    "high": 0.0000104,
    "close": 0.0000101,
    "volume": 45131680
  },
  {
    "date": "2025-12-14 01:00:00",
    "open": 0.0000101,
    "low": 0.0000098,
    "high": 0.0000107,
    "close": 0.0000103,
    "volume": 58313815
  },
  {
    "date": "2025-12-14 02:00:00",
    "open": 0.0000103,
    "low": 0.0000097,
    "high": 0.0000106,
    "close": 0.0000101,
    "volume": 60696889
  },
  {
    "date": "2025-12-14 03:00:00",
    "open": 0.0000101,
    "low": 0.0000096,
    "high": 0.0000106,
    "close": 0.0000097,
    "volume": 105682337
  },
  {
    "date": "2025-12-14 04:00:00",
    "open": 0.0000097,
    "low": 0.0000095,
    "high": 0.0000099,
    "close": 0.0000098,
    "volume": 41271780
  },
  {
    "date": "2025-12-14 05:00:00",
    "open": 0.0000098,
    "low": 0.0000098,
    "high": 0.0000098,
    "close": 0.0000098,
    "volume": 47159269
  },
  {
    "date": "2025-12-14 06:00:00",
    "open": 0.0000098,
    "low": 0.0000097,
    "high": 0.00001,
    "close": 0.0000099,
    "volume": 43174275
  },
  {
    "date": "2025-12-14 07:00:00",
    "open": 0.0000099,
    "low": 0.0000096,
    "high": 0.0000102,
    "close": 0.0000097,
    "volume": 124897779
  },
  {
    "date": "2025-12-14 08:00:00",
    "open": 0.0000097,
    "low": 0.0000093,
    "high": 0.0000101,
    "close": 0.0000099,
    "volume": 54804948
  },
  {
    "date": "2025-12-14 09:00:00",
    "open": 0.0000099,
    "low": 0.0000098,
    "high": 0.0000105,
    "close": 0.0000101,
    "volume": 56411282
  },
  {
    "date": "2025-12-14 10:00:00",
    "open": 0.0000101,
    "low": 0.00001,
    "high": 0.0000103,
    "close": 0.0000102,
    "volume": 61187813
  },
  {
    "date": "2025-12-14 11:00:00",
    "open": 0.0000102,
    "low": 0.0000102,
    "high": 0.0000103,
    "close": 0.0000103,
    "volume": 54264368
  },
  {
    "date": "2025-12-14 12:00:00",
    "open": 0.0000103,
    "low": 0.00001,
    "high": 0.0000106,
    "close": 0.0000101,
    "volume": 48388194
  },
  {
    "date": "2025-12-14 13:00:00",
    "open": 0.0000101,
    "low": 0.0000101,
    "high": 0.0000101,
    "close": 0.0000101,
    "volume": 40660526
  },
  {
    "date": "2025-12-14 14:00:00",
    "open": 0.0000101,
    "low": 0.00001,
    "high": 0.0000103,
    "close": 0.0000102,
    "volume": 64420074
  },
  {
    "date": "2025-12-14 15:00:00",
    "open": 0.0000102,
    "low": 0.00001,
    "high": 0.0000103,
    "close": 0.0000101,
    "volume": 61530234
  },
  {
    "date": "2025-12-14 16:00:00",
    "open": 0.0000101,
    "low": 0.0000101,
    "high": 0.0000101,
    "close": 0.0000101,
    "volume": 58637380
  },
  {
    "date": "2025-12-14 17:00:00",
    "open": 0.0000101,
    "low": 0.00001,
    "high": 0.0000106,
    "close": 0.0000103,
    "volume": 55368937
  },
  {
    "date": "2025-12-14 18:00:00",
    "open": 0.0000103,
    "low": 0.00001,
    "high": 0.0000105,
    "close": 0.0000101,
    "volume": 49888431
  },
  {
    "date": "2025-12-14 19:00:00",
    "open": 0.0000101,
    "low": 0.0000096,
    "high": 0.000011,
    "close": 0.0000105,
    "volume": 76243145
  },
  {
    "date": "2025-12-14 20:00:00",
    "open": 0.0000105,
    "low": 0.0000103,
    "high": 0.0000107,
    "close": 0.0000106,
    "volume": 62497286
  },
  {
    "date": "2025-12-14 21:00:00",
    "open": 0.0000106,
    "low": 0.0000104,
    "high": 0.0000108,
    "close": 0.0000107,
    "volume": 52796684
  },
  {
    "date": "2025-12-14 22:00:00",
    "open": 0.0000107,
    "low": 0.0000106,
    "high": 0.0000109,
    "close": 0.0000106,
    "volume": 59236800
  },
  {
    "date": "2025-12-14 23:00:00",
    "open": 0.0000106,
    "low": 0.0000103,
    "high": 0.0000107,
    "close": 0.0000105,
    "volume": 46686603
  },
  {
    "date": "2025-12-15 00:00:00",
    "open": 0.0000105,
    "low": 0.0000102,
    "high": 0.0000107,
    "close": 0.0000104,
    "volume": 41338944
  },
  {
    "date": "2025-12-15 01:00:00",
    "open": 0.0000104,
    "low": 0.0000104,
    "high": 0.0000104,
    "close": 0.0000104,
    "volume": 49149093
  },
  {
    "date": "2025-12-15 02:00:00",
    "open": 0.0000104,
    "low": 0.0000103,
    "high": 0.0000105,
    "close": 0.0000103,
    "volume": 44475300
  },
  {
    "date": "2025-12-15 03:00:00",
    "open": 0.0000103,
    "low": 0.0000103,
    "high": 0.0000103,
    "close": 0.0000103,
    "volume": 107824998
  },
  {
    "date": "2025-12-15 04:00:00",
    "open": 0.0000103,
    "low": 0.0000103,
    "high": 0.0000103,
    "close": 0.0000103,
    "volume": 44132532
  },
  {
    "date": "2025-12-15 05:00:00",
    "open": 0.0000103,
    "low": 0.0000103,
    "high": 0.0000105,
    "close": 0.0000104,
    "volume": 68021511
  },
  {
    "date": "2025-12-15 06:00:00",
    "open": 0.0000104,
    "low": 0.0000075,
    "high": 0.000011,
    "close": 0.0000093,
    "volume": 164583637
  },
  {
    "date": "2025-12-15 07:00:00",
    "open": 0.0000093,
    "low": 0.0000091,
    "high": 0.0000096,
    "close": 0.0000094,
    "volume": 52218381
  },
  {
    "date": "2025-12-15 08:00:00",
    "open": 0.0000094,
    "low": 0.0000094,
    "high": 0.0000094,
    "close": 0.0000094,
    "volume": 50938103
  },
  {
    "date": "2025-12-15 09:00:00",
    "open": 0.0000094,
    "low": 0.0000094,
    "high": 0.0000094,
    "close": 0.0000094,
    "volume": 56848689
  },
  {
    "date": "2025-12-15 10:00:00",
    "open": 0.0000094,
    "low": 0.0000093,
    "high": 0.0000097,
    "close": 0.0000095,
    "volume": 40591805
  },
  {
    "date": "2025-12-15 11:00:00",
    "open": 0.0000095,
    "low": 0.0000095,
    "high": 0.0000095,
    "close": 0.0000095,
    "volume": 48726365
  },
  {
    "date": "2025-12-15 12:00:00",
    "open": 0.0000095,
    "low": 0.0000095,
    "high": 0.0000095,
    "close": 0.0000095,
    "volume": 50186790
  },
  {
    "date": "2025-12-15 13:00:00",
    "open": 0.0000095,
    "low": 0.0000092,
    "high": 0.0000096,
    "close": 0.0000094,
    "volume": 56623902
  },
  {
    "date": "2025-12-15 14:00:00",
    "open": 0.0000094,
    "low": 0.000009,
    "high": 0.0000098,
    "close": 0.0000096,
    "volume": 63537219
  },
  {
    "date": "2025-12-15 15:00:00",
    "open": 0.0000096,
    "low": 0.0000093,
    "high": 0.0000098,
    "close": 0.0000095,
    "volume": 60938553
  },
  {
    "date": "2025-12-15 16:00:00",
    "open": 0.0000095,
    "low": 0.0000095,
    "high": 0.0000097,
    "close": 0.0000096,
    "volume": 57491677
  },
  {
    "date": "2025-12-15 17:00:00",
    "open": 0.0000096,
    "low": 0.0000092,
    "high": 0.00001,
    "close": 0.0000098,
    "volume": 57845220
  },
  {
    "date": "2025-12-15 18:00:00",
    "open": 0.0000098,
    "low": 0.0000097,
    "high": 0.0000103,
    "close": 0.00001,
    "volume": 52347081
  },
  {
    "date": "2025-12-15 19:00:00",
    "open": 0.00001,
    "low": 0.0000099,
    "high": 0.0000104,
    "close": 0.0000102,
    "volume": 57683440
  },
  {
    "date": "2025-12-15 20:00:00",
    "open": 0.0000102,
    "low": 0.0000088,
    "high": 0.0000125,
    "close": 0.0000111,
    "volume": 155449729
  },
  {
    "date": "2025-12-15 21:00:00",
    "open": 0.0000111,
    "low": 0.0000109,
    "high": 0.0000113,
    "close": 0.0000112,
    "volume": 51084141
  },
  {
    "date": "2025-12-15 22:00:00",
    "open": 0.0000112,
    "low": 0.0000111,
    "high": 0.0000114,
    "close": 0.0000113,
    "volume": 57883257
  },
  {
    "date": "2025-12-15 23:00:00",
    "open": 0.0000113,
    "low": 0.0000112,
    "high": 0.0000114,
    "close": 0.0000114,
    "volume": 59493530
  },
  {
    "date": "2025-12-16 00:00:00",
    "open": 0.0000114,
    "low": 0.0000099,
    "high": 0.0000119,
    "close": 0.0000107,
    "volume": 127547911
  }
]